export default function ErrorNotFound() {
  return <div>404 - Page Not Found</div>;
}
